import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { LaborTableResponseModel } from '@/types'

export const getLaborTableMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<LaborTableResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/labor-table`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
